/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import 'dayjs/locale/it';
import { Appointment_interface } from '../../../interfaces/Interfaces';

export interface AppointmentSliceState {
  appointments: Appointment_interface[];
  /**
   * Chiave della GetAll che ha prodotto `appointments` (data, vista e filtri,
   * getChiaveRichiestaAppuntamenti); null finché non è arrivata nessuna lista.
   * La pagina la confronta coi filtri correnti per sapere se la lista è già
   * quella giusta.
   */
  chiaveRichiesta: string | null;
  loadingAppointments: boolean;
  printComponent: any;
  refetch: boolean;
}

const initialState: AppointmentSliceState = {
  appointments: [],
  chiaveRichiesta: null,
  loadingAppointments: false,
  printComponent: null,
  refetch: false,
};

const AppointmentSlice = createSlice({
  name: 'BluBookingAppointment',
  initialState,
  reducers: {
    setRefetch(state: AppointmentSliceState) {
      state.refetch = !state.refetch;
    },

    // Lista e chiave insieme, in un'azione sola: non c'è mai un render con la
    // lista nuova e la chiave vecchia, o il contrario
    setAppointments(
      state: AppointmentSliceState,
      action: PayloadAction<{
        appointments: Appointment_interface[];
        chiaveRichiesta: string;
      }>
    ) {
      state.appointments = action.payload.appointments;
      state.chiaveRichiesta = action.payload.chiaveRichiesta;
    },
    setAppointmentsIndex(
      state: AppointmentSliceState,
      action: PayloadAction<{
        index: number;
        appointment: Appointment_interface;
      }>
    ) {
      state.appointments[action.payload.index] = action.payload.appointment;
    },
    setLoadingAppointments(
      state: AppointmentSliceState,
      action: PayloadAction<boolean>
    ) {
      state.loadingAppointments = action.payload;
    },

    setFilters(state: AppointmentSliceState, action: PayloadAction<any>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setPrintComponent(
      state: AppointmentSliceState,
      action: PayloadAction<any>
    ) {
      state.printComponent = action.payload;
    },
    resetAppointment() {
      return initialState;
    },
  },
});

export const {
  setRefetch,
  setAppointments,
  setLoadingAppointments,
  setAppointmentsIndex,
  setFilters,
  resetAppointment,
  setPrintComponent,
} = AppointmentSlice.actions;

export default AppointmentSlice.reducer;
